import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Div, Indicator } from 'legacyComponents/styled/lib';
import styled from 'styled-components';
import { Link } from 'core/routing';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';
import { media } from 'legacyComponents/styled/styleUtils';
import { Avatar } from 'apps/components/shared';

import { withNamespaces, Trans } from 'react-i18next';

@withNamespaces()
@observer
export class Curator extends React.Component {
  render() {
    const { collection } = this.props;
    const { manager } = collection;
    if (manager.loading) {
      return (
        <Div float='right'>
          <AvatarIndicator />
        </Div>
      );
    }
    const { creatorProfile } = collection;
    return (
      <Wrapper>
        <Link name='profile' params={{ profile: `${creatorProfile.username}` }}>
          <CuratorAvatar
            src={imageSrc(
              creatorProfile.avatar,
              creatorProfile.imageFallbackPath,
              mainConf.imgSizes.profile.small,
            )}
          />
        </Link>
        <CuratedBy>
          <Trans>A Collection by</Trans>:
        </CuratedBy>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  float: right;
  ${media.s`
    display: none;
  `}
`;

const AvatarIndicator = styled(Indicator)`
  width: 34px;
  height: 34px;
  border-radius: 100%;
  float: right;
`;

const CuratorAvatar = styled(Avatar)`
  width: 34px;
  height: 34px;
  margin-left: 10px;
  float: right;
  margin-top: -5px;
`;

const CuratedBy = styled.p`
  float: right;
  font-size: 12px;
  font-weight: 600;
  margin: 6px 2px 0 0;
`;

Curator.propTypes = {
  collection: PropTypes.object,
};
